module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-container"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('div', [_c('h4', {
    staticClass: "content-c2"
  }, [_vm._v("Copyright ©2017, ＊＊＊＊＊＊, Ltd. All Rights Reserved.")]), _vm._v(" "), _c('ul', {
    staticClass: "privacy"
  }, [_c('li', {
    staticClass: "content-c1"
  }, [_c('a', {
    staticClass: "content-c0",
    on: {
      "click": _vm.open1
    }
  }, [_vm._v("法律声明")])]), _vm._v(" "), _c('li', {
    staticClass: "content-c1"
  }, [_c('a', {
    staticClass: "content-c0",
    on: {
      "click": _vm.open2
    }
  }, [_vm._v("隐私条款")])])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "content-c3"
  }, [_vm._v("＊＊＊＊＊＊号")]), _vm._v(" "), _c('span', {
    staticClass: "content-c3"
  }, [_vm._v("＊＊＊＊＊＊＊＊＊＊号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "c4"
  }, [_c('div', [_c('li', {
    staticClass: "tel"
  }, [_c('a', {
    staticClass: "c5",
    attrs: {
      "target": "_blank"
    }
  }, [_vm._v("123456789")])]), _vm._v(" "), _c('li', {
    staticClass: "time"
  }, [_vm._v("周一至周日 10:00-23:00")])]), _vm._v(" "), _c('li', {
    staticClass: "online"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4fa342c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fa342c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/homePage/components/common/Footer.vue
// module id = 2705
// module chunks = 0